define([
	"dojo/_base/declare",
	"csi/table/New",
	"./PartMaterialBOMSectionMixin"
], function(declare,New,PartMaterialBOMSectionMixin) {

	return declare([New, PartMaterialBOMSectionMixin], {});
});
